export const findNextPendingSession = (sessions, role) => {
  if (!sessions?.length) return null;

  // Helper to extract session number from name like "Session 1"
  const getSessionNumber = (name) => {
    const match = name.match(/Session\s+(\d+)/i);
    return match ? parseInt(match[1], 10) : Infinity;
  };

  // Helper to check if a session's date+time is in the past
  const isSessionInPast = (session) => {
    const { date, time, timezone } = session;

    // Combine date and time into a single string e.g. "2026-01-10 10:00 AM EST"
    const dateTimeString = `${date.split("T")[0]} ${time} ${timezone}`;
    const sessionDate = new Date(dateTimeString);

    return sessionDate < new Date();
  };

  // Sort sessions by session number regardless of input order
  const sortedSessions = [...sessions].sort(
    (a, b) => getSessionNumber(a.name) - getSessionNumber(b.name)
  );

  // For managers, we want to find the next booked session across all sessions
  if (role === "manager") {
    const nextBookedSession = sortedSessions.find(
      (session) => session.status.toLowerCase() === "booked"
    );
    if (nextBookedSession) {
      return nextBookedSession;
    }
    return null; // No booked sessions found
  }

  // Find the first pending session
  for (let i = 0; i < sortedSessions.length; i++) {
    const session = sortedSessions[i];

    if (["completed", "no show"].includes(session.status.toLowerCase())) {
      continue;
    }

    // If this is the first session or the previous session's date is in the past,
    // return this pending session
    const previousSession = sortedSessions[i - 1];
    if (
      !previousSession ||
      isSessionInPast(previousSession) ||
      ["completed", "no show"].includes(previousSession.status.toLowerCase())
    ) {
      return session;
    }

    // Previous session is still in the future, return it instead
    return previousSession;
  }

  return null;
};
